module.exports = function (isMobile) {
  return {
    // default fake data
    defaultPowerOptions: [{
      productId: '6757458116681',
      variantId: [],
      tag: 'Recommended',
      productName: '10Kwh Power Kits',
      name: 'Get Set Kit (10kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757463720009',
      variantId: [],
      tag: 'Delux',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['15Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757464277065',
      variantId: [],
      tag: 'Regular',
      usage: 'Daily usage',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }],
    defaultComboOptions: [{
      id: 11,
      name: 'Ultimate Combo1',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '$',
      subs: [{
        id: 110,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }, {
      id: 12,
      name: 'Ultimate Combo2',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '$',
      subs: [{
        id: 123,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 124,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 126,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }],
    defaultSolarOptions: [{
      id: 111,
      name: '100W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '$',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 112,
      name: '400W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '$',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 113,
      name: '150W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '$',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }],
    // real data
    // power kit
    powerPack: {
      2: {
        productId: '6757458116681',
        variantId: ['39946294984777', '39946295017545', '39946295050313'],
        capacity: 2,
        productName: '电源系统（2度电）',
        name: '基础套装(2度电)',
        discountPrice: 3799,
        originalPrice: 4497,
        unit: '$',
        includes: ['磷酸铁锂电池（2度电） x1', '智能五合一充逆一体机', '线材包'],
        img: '/img/calculators/mm100/power-2kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-2kw.jpg',
        detailImg: '/img/calculators/mm100/power-2kw-detail.jpg'
      },
      4: {
        productId: '6757463720009',
        variantId: ['39946320314441', '39946320347209', '39946320379977'],
        capacity: 4,
        productName: '电源系统（4度电）',
        name: '基础套装(4度电)',
        discountPrice: 5199,
        originalPrice: 6496,
        unit: '$',
        includes: ['磷酸铁锂电池（2度电） x2', '智能五合一充逆一体机', '线材包'],
        img: '/img/calculators/mm100/power-4kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-4kw.jpg',
        detailImg: '/img/calculators/mm100/power-4kw-detail.jpg'
      },
      5: {
        productId: '6757464277065',
        variantId: ['39946322247753', '39946322280521', '39946322313289'],
        capacity: 5,
        productName: '电源系统（5度电）',
        name: '基础套装(5度电)',
        discountPrice: 5799,
        originalPrice: 7097,
        unit: '$',
        includes: ['磷酸铁锂电池（5度电） x1', '智能五合一充逆一体机', '线材包'],
        img: '/img/calculators/mm100/power-5kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-5kw.jpg',
        detailImg: '/img/calculators/mm100/power-5kw-detail.jpg'
      },
      10: {
        productId: '6757469388873',
        variantId: ['39946340499529', '39946340532297', '39946340565065'],
        capacity: 10,
        productName: '电源系统（10度电）',
        name: '基础套装(10度电)',
        discountPrice: 8799,
        originalPrice: 11696,
        unit: '$',
        includes: ['磷酸铁锂电池（5度电） x2', '智能五合一充逆一体机', '线材包'],
        img: '/img/calculators/mm100/power-10kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-10kw.jpg',
        detailImg: '/img/calculators/mm100/power-10kw-detail.jpg'
      },
      15: {
        productId: '6757470011465',
        variantId: ['39946344562761', '39946344595529', '39946344628297'],
        capacity: 15,
        productName: '电源系统（15度电）',
        name: '基础套装(15度电)',
        discountPrice: 11799,
        originalPrice: 16295,
        unit: '$',
        includes: ['磷酸铁锂电池（5度电） x3', '智能五合一充逆一体机', '线材包'],
        img: '/img/calculators/mm100/power-15kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-15kw.jpg',
        detailImg: '/img/calculators/mm100/power-15kw-detail.jpg'
      }
    },
    // combo
    comboPack: [{
      productId: 1,
      variantId: '',
      name: '使电量使用情况可视化、易操作。',
      discountPrice: 300,
      originalPrice: 538,
      unit: '$',
      subs: [{
        comboSubId: 'combo_1_sub_1',
        name: '智能配电盒',
        desc: '多达6路交流及12路直流控制，含过载保护及隔离功能，时刻守护车上电器、线路和人身安全',
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: '智能配电盒',
          desc: '多达6路交流及12路直流控制，含过载保护及隔离功能，时刻守护车上电器、线路和人身安全',
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: '交流输入',
            value: '220-240 V，50 Hz，最大输入电流30 A'
          }, {
            key: '直流输入',
            value: '10–30 V直流电，最大输入电流 70 A'
          }, {
            key: '交流输出',
            value: '6 路 (1/2: 20 A, 3/4/5/6: 10 A) 220-240 V, 50 Hz'
          }, {
            key: '直流输出',
            value: '6 路可控 + 6 路不可控, 每路最大输出电流20 A，10-30 V直流电'
          }, {
            key: '使用温度',
            value: '–25°C~60°C'
          }, {
            key: '储存温度',
            value: '–25°C~60°C'
          }, {
            key: '净重',
            value: '2.6 kg'
          }, {
            key: '尺寸',
            value: '35.4 cm x 21cm x 9.8 cm'
          }
          // {
          //     key: 'Tests and Certifications',
          //     value: 'CE, UL, FCC, EMC Class B',
          // },
          ]
        }
      }, {
        comboSubId: 'combo_1_sub_2',
        name: '电池平放扎带',
        desc: '安全稳固地装配电池',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }, {
      productId: 2,
      variantId: '',
      name: '添加智能发电机，并使电量使用情况可视化、易操作。',
      discountPrice: 1600,
      originalPrice: 2355,
      unit: '$',
      subs: [{
        comboSubId: 'combo_2_sub_1',
        name: '智能配电盒',
        desc: '多达6路交流及12路直流控制，含过载保护及隔离功能，时刻守护车上电器、线路和人身安全',
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: '智能配电盒',
          desc: '多达6路交流及12路直流控制，含过载保护及隔离功能，时刻守护车上电器、线路和人身安全',
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: '交流输入',
            value: '220-240 V，50 Hz，最大输入电流30 A'
          }, {
            key: '直流输入',
            value: '10–30 V直流电，最大输入电流 70 A'
          }, {
            key: '交流输出',
            value: '6 路 (1/2: 20 A, 3/4/5/6: 10 A) 220-240 V, 50 Hz'
          }, {
            key: '直流输出',
            value: '6 路可控 + 6 路不可控, 每路最大输出电流20 A，10-30 V直流电'
          }, {
            key: '使用温度',
            value: '–25°C~60°C'
          }, {
            key: '储存温度',
            value: '–25°C~60°C'
          }, {
            key: '净重',
            value: '2.6 kg'
          }, {
            key: '尺寸',
            value: '35.4 cm x 21cm x 9.8 cm'
          }
          // {
          //     key: 'Tests and Certifications',
          //     value: 'CE, UL, FCC, EMC Class B',
          // },
          ]
        }
      }, {
        comboSubId: 'combo_2_sub_2',
        name: '智触监控屏',
        desc: '控制和查看您的功耗',
        img: '/img/calculators/mm100/combo-console.jpg',
        imgH5: '/img/calculators/mm100H5/combo-console.jpg',
        details: {
          title: '智触监控屏',
          desc: '控制和查看您的功耗',
          img: '/img/calculators/mm100/combo-detail-console.jpg',
          imgH5: '/img/calculators/mm100H5/combo-console.jpg',
          specParams: [{
            key: '屏幕尺寸',
            value: '154.2 mm × 85.9 mm'
          }, {
            key: '触控',
            value: '支持'
          }, {
            key: '直流输入/ RJ45 通信接口',
            value: '12V / 1A, 最大功率12W'
          }, {
            key: '直流输入 / USB-C 接口',
            value: '5V / 2A, 最大功率10W'
          }, {
            key: '直流输出 / USB-A 接口',
            value: '5V / 1A, 最大功率5W'
          }, {
            key: '使用温度',
            value: '-20° C~50° C'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_3',
        name: '双燃料智能发电机',
        desc: '可以使用正浩双燃料发电机为48V全场景电源系统进行直流充电，相比传统发电机为传统储能电站发电，每度电可节省高达40%的燃料。',
        img: '/img/calculators/mm100/combo-generator.jpg',
        imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
        details: {
          title: '双燃料智能发电机',
          desc: '可以使用正浩双燃料发电机为48V全场景电源系统进行直流充电，相比传统发电机为传统储能电站发电，每度电可节省高达40%的燃料。',
          img: '/img/calculators/mm100/combo-detail-generator.jpg',
          imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
          specParams: [{
            key: '净重',
            value: '30.5 kg'
          }, {
            key: '长×宽×高',
            value: '597×300×475 mm'
          }, {
            key: '发动机型式',
            value: '单缸、四冲程、强制风冷、顶置式气门'
          }, {
            key: '燃料类型',
            value: '无铅汽油/液化石油气'
          }, {
            key: '额定功率',
            value: '汽油：1800 W（峰值1900 W）\n液化石油气：1600W(峰值1700W)'
          }, {
            key: '类型',
            value: '变频'
          }, {
            key: '油箱容积',
            value: '4 L'
          }, {
            key: '连续工作时间(汽油）',
            value: '3.5 小时(额定负载)'
          }, {
            key: '启动方式',
            value: '电启动'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_4',
        name: '电池平放扎带',
        desc: '安全稳固地装配电池',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }],
    // solar panel
    solarPack: [{
      productId: '6761262973001',
      variantId: '39962928152649',
      name: '2 * 100W刚性太阳能板 + 2 *100W刚性太阳能板安装脚件',
      discountPrice: 219,
      originalPrice: 219,
      // discountRate: 0.8,
      unit: '$',
      number: 0,
      capacity: 200,
      img: '/img/calculators/mm100/solar-100-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2 * 100W刚性太阳能板 + 2 *100W刚性太阳能板安装脚件',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
        specParams: [{
          key: '额定功率',
          value: '100W（+/-5w）'
        }, {
          key: '开路电压',
          value: '20.3V'
        }, {
          key: '短路电流',
          value: '6.3A'
        }, {
          key: '最大工作电压',
          value: '17.1V'
        }, {
          key: '最大工作电流',
          value: '5.9A'
        }, {
          key: '额定功率温度系数',
          value: '-0.39%/° C'
        }, {
          key: '开路电压温度系数',
          value: '-0.33%/° C'
        }, {
          key: '短路电流温度系数',
          value: '0.06%/° C'
        }, {
          key: '最大系统电压',
          value: '600VDC(UL)'
        }, {
          key: '最大保险丝电流',
          value: '15A'
        }, {
          key: '太阳能充电板重量',
          value: '约 6.2 千克'
        }, {
          key: '尺寸',
          value: '98*58.6*3 厘米'
        }]
      },
      question: {}
    }, {
      productId: '6761270444105',
      variantId: '39962923532361',
      name: '1 * 400W刚性太阳能板',
      discountPrice: 739,
      originalPrice: 739,
      // discountRate: 0.8,
      unit: '$',
      number: 0,
      capacity: 800,
      freeShip: 1,
      img: '/img/calculators/mm100/solar-400-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1 * 400W刚性太阳能板',
        img: '/img/calculators/mm100/solar-detail-400-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
        specParams: [{
          key: '额定功率',
          value: '400W(±3%)'
        }, {
          key: '开路电压',
          value: '37.10V(±3%)'
        }, {
          key: '短路电流',
          value: '13.79A(±5%)'
        }, {
          key: '最大工作电压',
          value: '31.00V'
        }, {
          key: '最大工作电流',
          value: '12.90A'
        }, {
          key: '额定功率温度系数',
          value: '-0.38%/°C'
        }, {
          key: '开路电压温度系数',
          value: '-0.35%/°C'
        }, {
          key: '短路电流温度系数',
          value: '0.06%/°C'
        }, {
          key: '最大系统电压',
          value: '1500VDC(UL)'
        }, {
          key: '最大保险丝电流',
          value: '25A'
        },
        // { key: 'Operating Temp.', value: '-20°C - +50°C' },
        {
          key: '净重',
          value: '约21.8kg'
        }, {
          key: '尺寸',
          value: '1722*1134*35mm'
        }]
      },
      question: {}
    }, {
      productId: '6761895231561',
      variantId: '39962853343305',
      name: '1*100W柔性太阳能板',
      discountPrice: 199,
      originalPrice: 199,
      // discountRate: 0.8,
      unit: '$',
      number: 0,
      capacity: 100,
      img: '/img/calculators/mm100/solar-100-flexible.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1*100W柔性太阳能板',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-flexible.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
        specParams: [{
          key: '额定功率',
          value: '100W（+/-5w）'
        }, {
          key: '开路电压',
          value: '20.3V'
        }, {
          key: '短路电流',
          value: '6.3A'
        }, {
          key: '最大工作电压',
          value: '17.1V'
        }, {
          key: '最大工作电流',
          value: '5.9A'
        }, {
          key: '额定功率温度系数',
          value: '-0.39%/°C'
        }, {
          key: '开路电压温度系数',
          value: '-0.33%/°C'
        }, {
          key: '短路电流温度系数',
          value: '0.06%/°C'
        }, {
          key: '最大系统电压',
          value: '600VDC(UL)'
        }, {
          key: '最大保险丝电流',
          value: '15A'
        }, {
          key: '重量',
          value: '约 2.3 千克'
        }, {
          key: '尺寸',
          value: '1055*612*25 毫米'
        }]
      },
      question: {}
    }, {
      productId: '6618094960713',
      variantId: '39998021697609',
      name: '1*400W 便携太阳能板',
      discountPrice: 1199,
      originalPrice: 1199,
      // discountRate: 0.8,
      unit: '$',
      number: 0,
      capacity: 400,
      locale: ['us', 'ca', 'au', 'jp', 'cn'],
      // only for us site
      img: '/img/calculators/mm100/solar-400-portable.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1*400W 便携太阳能板',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-400-portable.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
        specParams: [{
          key: '额定功率',
          value: '400W(±10W)'
        }, {
          key: '开路电压',
          value: '48V(Vmp 41V)'
        }, {
          key: '短路电流',
          value: '11A(Imp 9.8A)'
        }, {
          key: '效率',
          value: '22.6%'
        }, {
          key: '电池类型',
          value: '单晶硅'
        }, {
          key: '接口类型',
          value: 'MC4'
        }, {
          key: '太阳能充电板',
          value: '约16.0 千克'
        },
        // { key: 'Solar Panel', value: '33.1lbs(15.0KG)' },
        {
          key: '展开尺寸',
          value: '105.8*236.5*2.5 厘米'
        }, {
          key: '折叠尺寸',
          value: '105.8*62.0*2.5 厘米'
        }, {
          key: '功率表现温度系数',
          value: '-(0.39±0.02)%/k'
        }, {
          key: '电压表现温度系数',
          value: '-(0.33±0.03)%/k'
        }, {
          key: '电流表现温度系数',
          value: '+(0.06±0.015)%/k'
        }]
      },
      question: {}
    }],
    // bundle imgs when choose the bundle (left main image)  - variant_id
    bundleImgs: {
      39946294984777: 'power-2kw.jpg',
      39946295017545: 'bundle-2kw-dp.jpg',
      39946295050313: 'bundle-2kw-all.jpg',
      39946320314441: 'power-4kw.jpg',
      39946320347209: 'bundle-4kw-dp.jpg',
      39946320379977: 'bundle-4kw-all.jpg',
      39946322247753: 'power-5kw.jpg',
      39946322280521: 'bundle-5kw-dp.jpg',
      39946322313289: 'bundle-5kw-all.jpg',
      39946340499529: 'power-10kw.jpg',
      39946340532297: 'bundle-10kw-dp.jpg',
      39946340565065: 'bundle-10kw-all.jpg',
      39946344562761: 'power-15kw.jpg',
      39946344595529: 'bundle-15kw-dp.jpg',
      39946344628297: 'bundle-15kw-all.jpg'
    },
    // solar price discount rate => 2022-06-22: not in use anymore
    // solarDiscountRate: {
    //     // product_id
    //     '6757458116681': {
    //         '0': 0.92,
    //         '1': 0.87,
    //         '2': 0.85,
    //     },
    //     '6757463720009': {
    //         '0': 0.87,
    //         '1': 0.84,
    //         '2': 0.82,
    //     },
    //     '6757464277065': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.85,
    //     },
    //     '6757469388873': {
    //         '0': 0.87,
    //         '1': 0.85,
    //         '2': 0.8,
    //     },
    //     '6757470011465': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.82,
    //     },
    // },

    // combo's original price under the bundle
    comboPrice: {
      // productId
      6757458116681: {
        original: [0, 538, 2355],
        discount: [0, 300, 1600]
      },
      6757463720009: {
        original: [0, 577, 2394],
        discount: [0, 300, 1600]
      },
      6757464277065: {
        original: [0, 538, 2355],
        discount: [0, 300, 1600]
      },
      6757469388873: {
        original: [0, 577, 2394],
        discount: [0, 300, 1600]
      },
      6757470011465: {
        original: [0, 616, 2433],
        discount: [0, 300, 1600]
      }
    },
    // common power kit's details
    powerDetails: {
      title: '智控五合一充逆一体机',
      img: '/img/calculators/mm100/defaultDetail.jpg',
      desc: '智控五合一充逆一体机是48V全场景电源系统的核心，可为您的房车或离网小屋节省宝贵的空间。智控五合一充逆一体机将1套逆充一体机、1套DC-DC行车充电器、1套DC-DC降压转换器、2套MPPT太阳能充电控制器、1套电池并联配电模块全部集成在一个单元中，使安装非常简单。',
      specParams: [{
        key: '净重',
        value: '14kg'
      }, {
        key: '尺寸',
        value: '48cm x 14 cm x 30 cm'
      },
      // {
      //     key: 'Testing and Certification',
      //     value: 'CE, UL, FCC',
      // },
      {
        key: 'WI-FI',
        value: '支持'
      }, {
        key: '蓝牙',
        value: '支持'
      }, {
        key: '交流输出',
        value: '纯正弦波，3600 W（峰值 7200 W，100 ms），220V，50Hz\n 当40°C < 环境温度 < 60°C时，输出功率线性降额至1800 W\n 当电池电压 < 49 V 时，输出功率降额至3000 W'
      }, {
        key: '直流输出',
        value: '13.6 V 70 A，最大功率1000 W\n 或26.4 V 60 A，最大功率1600 W'
      }, {
        key: '交流输入功率',
        value: 'X-Stream 快充最大功率3000 W，最大电流15 A'
      }, {
        key: '交流输入电压',
        value: '220-240 V，50 Hz/60 Hz'
      }, {
        key: '太阳能充电输入接口',
        value: '15–60V 30A, 最大功率1600 W'
      }, {
        key: '行车发电机充电输入接口',
        value: '13–60 V 60 A, 最大功率1000 W'
      },
      // {
      //     key: 'Best Operating Temperature',
      //     value: '68°F to 86°F (20°C to 30°C)',
      // },
      // {
      //     key: 'Discharge Temperature',
      //     value: '-13°F to 140°F (-25°C to 60°C)',
      // },
      {
        key: '使用温度',
        value: '–25° C ~ 60° C'
      }, {
        key: '储存温度',
        value: '–25° C ~60° C'
      }]
    },
    // common solar panel's questions
    solarQuestion: {
      text: '根据平均80%的太阳能板输入和5小时的阳光计算'
    },
    // installations
    installOptions: [{
      variantId: 0,
      i18n: 'self'
    }, {
      productId: '6776213012553',
      variantId: '40019530055753',
      i18n: 'expert',
      i18n_des: 'pro'
    }],
    // tax price tag
    taxPriceTag: {
      jp: '(税込)'
    },
    isPriveReverseFlag: false,
    wire: {
      name: '线材包 + 电池平放扎带'
    },
    installTerms: {
      title: '免费安装条款和条件*',
      text: '1. 2022.08.25 至 2022.09.30 期间的订单将有资格享受此限时优惠。\n2.对于正浩安装网络内的地址，正浩会联系您预约免费安装服务。\n3.对于正浩安装网络以外的地址，客户可以选择本地安装。正浩将报销电源系统产品的安装成本。',
      sup: '*正浩保留最终解释权。'
    }
  };
};